const NEAR_BOTTOM = 40;
let bound = false;

function append(list: HTMLElement, html: string): void {
  const shown = new Set(Array.from(list.querySelectorAll<HTMLElement>("[data-ch-key]"), (el) => el.dataset.chKey));
  const batch = document.createElement("template");
  batch.innerHTML = html;
  batch.content.querySelectorAll<HTMLElement>("[data-ch-key]").forEach((entry) => {
    if (!shown.has(entry.dataset.chKey)) list.appendChild(entry);
  });
}

async function loadMore(list: HTMLElement): Promise<void> {
  const url = list.dataset.chUrl;
  const total = Number(list.dataset.chTotal || 0);
  const offset = list.querySelectorAll(".ch-entry").length;
  if (!url || list.dataset.chLoading === "1" || offset >= total) return;

  list.dataset.chLoading = "1";
  const loader = document.createElement("div");
  loader.className = "ch-loading";
  loader.textContent = "Loading…";
  list.appendChild(loader);

  try {
    const response = await fetch(`${url}?offset=${offset}`, { headers: { Accept: "text/html" }, credentials: "same-origin" });
    if (!response.ok) throw new Error(String(response.status));
    const html = (await response.text()).trim();
    loader.remove();
    list.dataset.chTotal = response.headers.get("X-Contact-History-Total") || String(offset);
    append(list, html);
  } catch {
    loader.remove();
  } finally {
    delete list.dataset.chLoading;
  }
}

export function initContactHistoryList(): void {
  if (bound) return;
  bound = true;

  document.addEventListener("scroll", (e) => {
    const list = e.target instanceof HTMLElement ? e.target.closest<HTMLElement>("[data-ch-list]") : null;
    if (list && list.scrollTop + list.clientHeight >= list.scrollHeight - NEAR_BOTTOM) void loadMore(list);
  }, true);
}
